/** Normalizes customer-facing product names without changing stored catalog data. */
export const normalizeProductDisplayName = (name: string | null | undefined): string => {
  const value = (name ?? "").trim();
  return value.replace(/БПК[\s‐‑‒–—-]*157/giu, "BPC-157");
};

export const getProductDisplayName = (
  localizedName: string | null | undefined,
  latinName: string | null | undefined,
): string => normalizeProductDisplayName(localizedName || latinName || "Товар");